// src/pages/Signup.js
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { signUp } from "../../Api/auth";
import { toast, ToastContainer } from "react-toastify";
import axiosInstance from "../../axiosInstance";
import "react-toastify/dist/ReactToastify.css";
import FormError from "./FormError";

const Signup = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    email: "",
    username: "",
    password: "",
    confirm_password: "",
    userRole: 1,
  });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [roles, setRoles] = useState([]);
  const [fieldErrors, setFieldErrors] = useState({
    email: "",
    username: "",
    password: "",
    confirm_password: "",
  });

  useEffect(() => {
    const fetchRoles = async () => {
      try {
        const response = await axiosInstance.get("/api/v1/lookups/roles");
        setRoles(response.data.items);
      } catch (error) {
        toast.error(error.response?.data?.detail || "خطأ في تحميل الأدوار");
      }
    };
    fetchRoles();
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleRoleChange = (e) => {
    setFormData({ ...formData, userRole: parseInt(e.target.value) });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    toast.dismiss();
    setError("");
    setSuccess("");
    setFieldErrors({
      email: "",
      username: "",
      password: "",
      confirm_password: "",
    });

    // التحقق من صحة الحقول
    let isValid = true;
    let errors = {
      email: "",
      username: "",
      password: "",
      confirm_password: "",
    };

    if (!formData.email) {
      isValid = false;
      errors.email = t("register.allFieldsRequired");
    } else {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(formData.email)) {
        isValid = false;
        errors.email = t("register.invalidEmail");
      }
    }

    if (!formData.username) {
      isValid = false;
      errors.username = t("register.allFieldsRequired");
    }

    if (!formData.password) {
      isValid = false;
      errors.password = t("register.allFieldsRequired");
    } else {
      const passwordStrength = /^(?=.*[A-Z])(?=.*\d).{8,}$/;
      if (!passwordStrength.test(formData.password)) {
        isValid = false;
        errors.password = t("register.weakPassword");
      }
    }

    if (!formData.confirm_password) {
      isValid = false;
      errors.confirm_password = t("register.allFieldsRequired");
    } else if (formData.password !== formData.confirm_password) {
      isValid = false;
      errors.confirm_password = t("register.passwordMismatch");
    }

    setFieldErrors(errors);

    if (!isValid) {
      toast.error(t("register.formInvalid"));
      return;
    }

    setIsLoading(true);

    const requestData = {
      email: formData.email,
      password: formData.password,
      passwordConfirmation: formData.confirm_password,
      fullName: formData.username,
      userRole: formData.userRole,
    };

    try {
      await signUp(requestData);
      setSuccess(t("register.successMessage"));
      toast.success(t("register.registrationSuccess"));

      setTimeout(() => {
        navigate("/confirm-email", { state: { email: formData.email } });
      }, 3000);
    } catch (error) {
      const errorMessage =
        error.detail || error.title || error.message || t("login.serverError");

      setError(errorMessage);
      toast.error(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <section className="py-5">
        <div className="container py-4">
          <div className="row justify-content-center">
            <div className="col-lg-6">
              <div className="card border-0 shadow-sm">
                <div className="card-body p-4 p-md-5">
                  <h2 className="text-center fw-bold text-primary-custom mb-4">
                    {t("register.title")}
                  </h2>
                  {/* <p className="text-muted text-center mb-4">
                    {t("register.subtitle")}
                  </p> */}

                  {/* رسائل الخطأ والنجاح */}
                  {error && <p className="text-danger">{error}</p>}
                  {success && <p className="text-success">{success}</p>}

                  <form onSubmit={handleSubmit} className="needs-validation">
                    <div className="mb-4">
                      <div className="form-floating">
                        <input
                          type="text"
                          name="username"
                          value={formData.username}
                          onChange={handleChange}
                          className={`form-control ${fieldErrors.username ? "is-invalid" : ""}`}
                          id="fullName"
                          placeholder={t("register.fullName")}
                        />
                        <label htmlFor="fullName">
                          {t("register.fullName")}
                        </label>
                        <FormError errorMessage={fieldErrors.username} />
                      </div>
                    </div>

                    <div className="mb-4">
                      <div className="form-floating">
                        <input
                          type="email"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          className={`form-control ${fieldErrors.username ? "is-invalid" : ""}`}
                          id="email"
                          placeholder={t("register.email")}
                          
                        />
                        <label htmlFor="email">{t("register.email")}</label>
                        <FormError errorMessage={fieldErrors.email} />
                      </div>
                    </div>

                    <div className="mb-4">
                      <div className="form-floating">
                        <input
                          type="password"
                          name="password"
                          value={formData.password}
                          onChange={handleChange}
                          className={`form-control ${fieldErrors.username ? "is-invalid" : ""}`}
                          id="password"
                          placeholder={t("register.password")}
                          
                        />
                        <label htmlFor="password">
                          {t("register.password")}
                        </label>
                        <FormError errorMessage={fieldErrors.password} />
                      </div>
                    </div>

                    <div className="mb-4">
                      <div className="form-floating">
                        <input
                          type="password"
                          name="confirm_password"
                          value={formData.confirm_password}
                          onChange={handleChange}
                          className={`form-control ${fieldErrors.username ? "is-invalid" : ""}`}
                          id="confirmPassword"
                          placeholder={t("register.confirmPassword")}
                          
                        />
                        <label htmlFor="confirmPassword">
                          {t("register.confirmPassword")}
                        </label>
                        <FormError
                          errorMessage={fieldErrors.confirm_password}
                        />
                      </div>
                    </div>

                    <div className="mb-4">
                      <label className="form-label fw-bold">
                        {t("register.accountType")}
                      </label>
                      <div className="row g-2">
                        {roles.map((role) => (
                          <div className="col-md-4" key={role.id}>
                            <div
                              className={`form-check card account-type-card p-3 text-center ${
                                formData.userRole === role.id
                                  ? "border-primary"
                                  : ""
                              }`}
                            >
                              <input
                                type="radio"
                                name="userRole"
                                id={`role-${role.id}`}
                                value={role.id}
                                checked={formData.userRole === role.id}
                                onChange={handleRoleChange}
                                className={`form-check-input ${fieldErrors.username ? "is-invalid" : ""}`}

                                
                              />
                              <label
                                className="form-check-label w-100"
                                htmlFor={`role-${role.id}`}
                              >
                                <div className="mb-2">
                                  <i
                                    className={`fa-2x text-primary-custom ${
                                      role.icon || "fas fa-user"
                                    }`}
                                  ></i>
                                </div>
                                <h6 className="mb-0">{role.name}</h6>
                                <small className="text-muted">
                                  {role.description}
                                </small>
                              </label>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>

                    <div className="mb-4">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          
                          type="checkbox"
                          id="termsCheck"
                          
                        />
                        <label
                          className="form-check-label"
                          htmlFor="termsCheck"
                        >
                          {t("register.termsAndConditions")}
                        </label>
                      </div>
                    </div>

                    <div className="mb-4 text-center">
                      <button
                        type="submit"
                        className="btn btn-primary w-100"
                        disabled={isLoading}
                      >
                        {isLoading
                          ? t("loading")
                          : t("register.registerButton")}
                      </button>
                    </div>
                    <div class="text-center">
                      <p className="mb-0">
                      {t("register.alreadyHaveAccount")}{" "}
                      <a
                          href="/login"
                          class="text-decoration-none"
                        >
                      {t("register.login")}
                      </a>
                      </p>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <ToastContainer />
    </>
  );
};

export default Signup;
